import type { MonospaceUser } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { SystemWorkspaceMember } from './service-account';
import { UserOrgRole } from './user-org-role';

export const User = RStoreSchema.withItemType<MonospaceUser>().defineCollection({
	name: 'MonospaceUser',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: [
			'id',
			'email',
			'fullName',
			'isService',
			'avatarId',
			'appearance',
		],
		endpoint: 'system/users',
	},
});

export const UserRelations = RStoreSchema.defineRelations(User, ({ collection }) => ({
	orgRole: {
		to: collection(UserOrgRole, {
			on: {
				'MonospaceUserOrgRole.userId': 'MonospaceUser.id',
			},
		}),
	},
	workspaces: {
		to: collection(SystemWorkspaceMember, {
			on: {
				'MonospaceWorkspaceMember.userId': 'MonospaceUser.id',
			},
		}),
		many: true,
	},
}));
